import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./ForgotPassword.css";
import PhoneInput from "react-phone-input-2";
import { validateForm } from "../../Utils/validate";
import { gettoastsuccess, gettoastwarning, handleFirebaseError } from "../../Utils/Common";
import CustomLoader from "../../components/CustomLoader";
import API from '../../Utils/Api';
import { auth } from "../../Utils/firebase";
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [inputs, setInputs] = useState({ country_code: '+353', mobile_number: '', full_mobile_number: '' });
  const [errors, setErrors] = useState({});
  /* ---- Send OTP ---- */
  const setupRecaptcha = () => {
    // avoid re-creating verifier multiple times
    if (!window.recaptchaVerifier) {
      window.recaptchaVerifier = new RecaptchaVerifier(
        auth,
        "recaptcha-container",
        {
          size: "invisible",
          callback: () => console.log("reCAPTCHA verified"),
        }
      );
    }
  };

  const sendOtp = async (id) => {
    setLoading(true);
    try {
      setupRecaptcha();
      const appVerifier = window.recaptchaVerifier;
      const phoneNumber = inputs.country_code + inputs.mobile_number
      const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, appVerifier);
      const verificationId = confirmationResult.verificationId;
      setLoading(false);
      gettoastsuccess('OTP sent!', '', 1000);
      setTimeout(() => {
        navigate("/otp/", { state: { ...inputs, id, verificationId, origin: 'forgot_password' } });
      }, 1000);
    } catch (error) {
      setLoading(false);
      console.log("SMS not sent", error?.message);
      handleFirebaseError(error)
    }
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    const fields = [
      { field: 'mobile_number', label: 'Phone Number', rules: 'required|number', value: inputs.mobile_number }
    ];
    const errors = validateForm(fields);
    if (Object.keys(errors).length > 0) {
      setErrors(errors);
    } else {
      setErrors({});
      doForgotPassword();
    }
  }
  const doForgotPassword = async () => {
    setLoading(true);
    let error;
    try {
      console.log('forgot_password inputs', inputs);
      API.post('forgot_password', inputs)
        .then(response => {
          setLoading(false);
          const apiResponse = response.data?.data;
          console.log('forgot_password response', response.data);
          if (response.data.status === false) {
            gettoastwarning(response.data.message);
          } else {
            // Send OTP
            sendOtp(apiResponse?.id);
          }
        }).catch(e => {
          error = e.message;
          gettoastwarning(error);
        });
    } catch (e) {
      setLoading(false);
      error = e.message;
      gettoastwarning(error);
    }
  };
  useEffect(() => {
    document.title = `Forgot Password | Your Friend My Friend`;
    document.getElementById('bodywrap').className = 'brand';
  }, []);

  return (
    <>
      <CustomLoader loading={loading} />
      <div className="container-fluid d-flex align-items-center justify-content-center min-vh-100 lo-oma position-relative">
        <div className="back-btn d-flex gap-1" onClick={() => navigate(-1)}>
          <img
            src={process.env.REACT_APP_BASE_URL + "assests/images/icon_back.png"}
            alt="back"
            className="img-fluid input-icon"
          />
          back
        </div>
        <div className="row w-100 my-5">
          <div className="col-md-6 col-lg-4 mx-auto">
            <div className="p-2">
              <h3 className="text-center">Forgot password</h3>
              <p className="text-center omas-p mb-0">Enter the phone number associated</p>
              <p className="text-center omas-p niku">with your account.</p>
              <form method="post" onSubmit={handleSubmit} encType="multipart/form-data">
                {/* Phone Number */}
                <div className="mb-3">
                  <PhoneInput
                    country={"ie"}
                    placeholder="Mobile number"
                    inputProps={{
                      name: "full_mobile_number",
                      required: true,
                      autoFocus: false,
                    }}
                    inputStyle={{ width: "100%" }}
                    value={inputs.full_mobile_number}
                    containerClass={`${errors.mobile_number && 'form-error'}`}
                    onChange={(value, countryData = {}, event) => {
                      const dialCode = countryData.dialCode || '';
                      // Remove dial code from the value (with '+' just to be safe)
                      let numberWithoutCode = value;
                      if (dialCode) {
                        const cleanDial = `+${dialCode}`;
                        if (value.startsWith(cleanDial)) {
                          numberWithoutCode = value.slice(cleanDial.length);
                        } else if (value.startsWith(dialCode)) {
                          numberWithoutCode = value.slice(dialCode.length);
                        }
                      }
                      setInputs({ ...inputs, country_code: `+${dialCode}`, mobile_number: numberWithoutCode, full_mobile_number: `+${dialCode}${numberWithoutCode}` })
                    }}
                  />
                  {errors.mobile_number && (
                    <p className="text-danger error-text">{errors.mobile_number}</p>
                  )}
                </div>

                {/* Submit button */}
                <div className="d-grid mb-3 text-center">
                  <button className="logus-in" type="submit">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div id="recaptcha-container"></div>
    </>
  );
};

export default ForgotPassword;
